export enum ConnectionStatus {
  Connected = 1,
  Disconnected,
  Pending,
}

export interface ConnectToZillowSetting {
  screenName: string;
  enabled: boolean;
  connectionStatus: ConnectionStatus;
  profileUrl: string;
  profileDisplayUrl: string;
}
